// src/components/TeamSection.jsx
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // ensure installed
import { Link } from 'react-router-dom';

const defaultMembers = [
  {
    name: "Boys Hostel in Baner",
    role: "Check services",
    img: "./images/keyword/9.jpg",
    path: "/boys-hostel-in-baner",
  },
  {
    name: "PG in Pune",
    role: "Check services",
    img: "./images/keyword/1.jpg",
    path: "/pg-in-pune",
  },
  {
    name: "Girls Hostels in Baner",
    role: "Check services",
    img: "./images/keyword/8.jpg",
    path: "/girls-hostels-in-baner",
  },
  {
    name: "PG for Students in Baner Pune",
    role: "Check services",
    img: "./images/services/4.jpg",
    path: "/pg-for-students-in-baner-pune",
  },
  {
    name: "PG for Working Professionals Pune",
    role: "Check services",
    img: "./images/services/5.jpg",
    path: "/pg-for-working-professionals-pune",
  },
  {
    name: "Paying Guest Near Hinjewadi IT Park Pune",
    role: "Check services",
    img: "./images/services/6.jpg",
    path: "/paying-guest-near-hinjewadi-it-park-pune",
  },
  {
    name: "Hostel in Pune",
    role: "Check services",
    img: "./images/services/7.jpg",
    path: "/hostel-in-pune",
  },
  {
    name: "PG in Baner Balewadi",
    role: "Check services",
    img: "./images/services/8.jpg",
    path: "/pg-in-baner-balewadi",
  },
  {
    name: "Paying Guest Hostel in Baner",
    role: "Check services",
    img: "./images/services/9.jpg",
    path: "/paying-guest-hostel-in-baner",
  },
];


export default function TeamSection({ members = defaultMembers }) {
  return (
   <>
      
<section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Services </h1>
       
      </div>
    </section>
   
    <section className="team-section">
      <div className="auto-container">
        {/* Sec Title */}
        <div className="sec-title centered">
          <h3>
            We’re architects, planners, engineers, strategists and
            <br />
            industry specialists spanning hundreds of At Shree Swami Samarth PG, we take pride in offering exceptional
services designed to elevate your living experience and ensure utmost convenience throughout your stay.
          </h3>
          <div className="separator"></div>
        </div>

        <div className="row clearfix">
          {members.map((m, i) => (
          <div className="team-member col-md-4 col-sm-6 col-xs-12" key={i}>
  <div className="inner-box">
    <div className="image">
      <Link to={m.path}>
        <img src={m.img} alt={m.name} />
      </Link>
    </div>
    <div className="lower-box">
      <h3>
        <Link to={m.path}>{m.name}</Link>
      </h3>
      <div className="designation">{m.role}</div>
    </div>
  </div>
</div>

          ))}
        </div>
      </div>
    </section>
   </>
  );
}
